import '../../../../../core/assets/js/core'
import 'intersection-observer';
import Typed from "typed.js";
import '../css/app.scss';

var $searchModal = $('#search-modal');
var $mainMenuModal = $('#main-menu-modal');
var $categoriesModal = $('#marketplace-categories-modal').modal();
var intersect = document.getElementById('main-menu-intersect');

$.fn.observe = function(callback) {
    var observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                callback($(entry.target));
                observer.unobserve(entry.target);
            }
        });
    }, {
        root: null
    });
    return $(this).each(function () {
        observer.observe(this);
    });
}
$mainMenuModal
    .on('click', 'a[data-tab]', function () {
        var $el = $(this);
        var tab = $el.data('tab');
        $mainMenuModal.find('a[data-tab]').removeClass('is-active');
        $mainMenuModal
            .find('.tab[data-tab]').removeClass('is-active')
            .filter('.tab[data-tab="' + tab + '"]').addClass('is-active');

        $el.addClass('is-active');
        if ($mainMenuModal.data('typed')) {
            if (tab === 'search') {
                $mainMenuModal.data('typed').start();
            } else {
                $mainMenuModal.data('typed').stop();
            }
        }
        return false;
    })
    .on('click', 'a.category[data-id]', function() {
        if (!$categoriesModal.data('modal')) {
            $categoriesModal.modal();
        }
        $categoriesModal.data('category', $(this).data('id'));
        $categoriesModal.modal('show');
        return false;
    })
    .on('focus', '.input', function() {
        var $fakeInput = $(this);
        var $input = $searchModal.find('input:not([type="hidden"])');
        $searchModal.one('modal:show', function() {
            var val = $input.val();
            $fakeInput.blur();
            $input.focus();
            $input.val('');
            if (val.length) {
                $input.val(val);
            }
        });
        $searchModal.modal('show');
        return true;
    })
    .one('modal:show', function() {
        var typed;
        var observer;
        $mainMenuModal.on('modal:shown', function() {
            if (!typed) {
                typed = new Typed(document.getElementById('main-menu-typing-prompt'), {
                    strings: ['unic?', 'creativ?', 'special?'],
                    typeSpeed: 50,
                    backSpeed: 50,
                    backDelay: 1500,
                    smartBackspace: false,
                    loop: false,
                    shuffle: false,
                    showCursor: false,
                });
                typed.stop();
                typed.reset();
                $mainMenuModal.data('typed', typed);
            }

            if (!observer) {
                observer = new IntersectionObserver((entries) => {
                    entries.forEach(function(entry) {
                        if (!entry.isIntersecting && !$mainMenuModal.hasClass('is-scrolled')) {
                            $mainMenuModal.addClass('is-scrolled');
                        } else if (entry.isIntersecting && $mainMenuModal.hasClass('is-scrolled')) {
                            $mainMenuModal.removeClass('is-scrolled');
                        }
                    });
                }, {
                    root: $mainMenuModal.find('section')[0]
                })
            }
            observer.observe(intersect);
            if ($mainMenuModal.data('tab') === 'search') {
                window.requestAnimationFrame(() => {
                    typed.start();
                })
            }
        })
        $mainMenuModal.on('modal:hidden', function () {
            typed.stop();
            typed.reset();
            observer.unobserve(intersect);
        })
    })
    .find('.form').on('click', '.icon[data-icon="search"]', function () {
    $(this).prev().focus();
    return false;
})

$categoriesModal.on('modal:show', function() {
    let category = parseInt($categoriesModal.data('category') || '0');
    if (category) {
        $categoriesModal.data('slidingMenu').slideTo(category);
        $categoriesModal.data('category', 0);
    } else {
        $categoriesModal.data('slidingMenu').slideTo(0);
    }
});
$searchModal
    .one('modal:show', function () {
        var requests = [];
        var timeout;
        var $input = $searchModal.find('input');
        var searchHistory;
        var time;
        try {
            searchHistory = JSON.parse(localStorage.getItem('searchHistory'));
        } catch (e) {
            searchHistory = null;
        }
        if (!searchHistory) {
            searchHistory = [];
        }

        searchHistory = searchHistory.filter(function(r) {
            return r.query.length >= 2;
        }).slice();

        if (!$searchModal.data('init')) {
            var $card = $searchModal.find('.results-card');
            var $list = $card.find('.list').first();
            var $templateItems = $searchModal.find('.list-item');
            var results = [];
            var $invisibleListStack = $('<div></div>');
            var saveToHistory = function(suggestion) {
                var suggestionIdx = searchHistory.findIndex((s) => s.title === suggestion.title
                    && s.subtitle === suggestion.subtitle
                    && s.query === suggestion.query
                    && s.url === suggestion.url
                );
                if (suggestion) {
                    if (suggestionIdx === -1) {
                        searchHistory.unshift(suggestion);
                        searchHistory = searchHistory.slice(0, 10);
                    } else {
                        searchHistory.splice(suggestionIdx, 1);
                        searchHistory.unshift(suggestion);
                    }
                }
                try {
                    localStorage.setItem('searchHistory', JSON.stringify(searchHistory));
                } catch (e) {}
            }
            var showList = function() {
                var $items = $invisibleListStack.children();
                if ($items.length) {
                    $list.html('').append($items);
                    $searchModal.addClass('has-results');
                    $invisibleListStack.html('');
                } else {
                    $list.html('');
                    $searchModal.removeClass('has-results')
                }
                $searchModal.removeClass('is-loading');
            }
            var fillItems = function(type, values) {
                if (values && values.length > 0) {
                    values.forEach(function(v) {
                        var $item = $templateItems.filter(`.type-${type}`).first().clone();
                        $item.attr('href', v.url);
                        $item.data('result', v);
                        $item.find('.item-title').html(v.title);
                        if (v.subtitle) {
                            $item.find('.item-text').html(v.subtitle);
                        } else {
                            $item.find('.item-text').remove();
                        }
                        $item.removeAttr('style');
                        $invisibleListStack.append($item)
                    })
                }
            }
            var q = '';
            $searchModal
                .data('init', 1)
                .on('input', 'input', function(e) {
                    var $el = $(this);
                    var val = $el.val().trim();

                    clearTimeout(timeout);

                    while(requests.length > 0) {
                        requests.shift().abort();
                    }

                    q = val;

                    $searchModal.addClass('is-loading');
                    $el.closest('.field').toggleClass('is-filled', val.length > 0);
                    $invisibleListStack.html('');


                    if (val.length < 2) {
                        if (searchHistory.length > 0) {
                            fillItems('history', searchHistory)
                            showList()
                        } else {
                            showList()
                        }
                        $searchModal.removeClass('is-loading');
                        return false;
                    }
                    timeout = setTimeout(function() {
                        requests.push($.getJSON(routes.search.suggest, {q: val}, function(response) {
                            results = response;
                            if (response.suggested && response.suggested.length) {
                                fillItems('suggested', [response.suggested.shift()])
                            }

                            if (!response.shopSearch) {
                                if (response.categories && response.categories.length) {
                                    fillItems('categories', response.categories)
                                }

                                if (response.suggested && response.suggested.length) {
                                    fillItems('suggested', response.suggested)
                                }
                            } else {
                                if (response.shops && response.shops.length) {
                                    fillItems('shops', response.shops)
                                }
                            }
                            showList();
                        }));
                    }, 250)
                    return true;
                })
                .on('mousedown', '.reset', function (e) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                    $input.val('').trigger('input');
                    return false;
                })
                .on('click', '.list-item', function () {
                    var $el = $(this);
                    var result = $el.data('result') || '';

                    $input.val('');
                    preloader(1);
                    $.post(
                        routes.search.collect,
                        {query: q, results: results, selected: result},
                        function () {
                            saveToHistory(result);
                            location.href = $el.attr('href');
                        },
                        'json'
                    );


                    return false;
                })
                .on('submit', 'form', function(e) {
                    var $form = $searchModal.find('form');
                    if ($form.data('skip')) {
                        return true;
                    }

                    e.preventDefault();
                    if (q.length < 2) {
                        return false;
                    }
                    preloader(true);
                    $.post(
                        routes.search.collect,
                        {query: q, results: results, selected: []},
                        function () {
                            var i;
                            if (results.categories) {
                                for (i = 0; i < results.categories.length; i++) {
                                    if (results.categories[i].exactMatch) {
                                        location.href = results.categories[i].url;
                                        return false;
                                    }
                                }
                            }
                            saveToHistory({query: q, title: q, url: routes.search.general.replace('_q_', q)});
                            $form.data('skip', 1);
                            $form.submit();
                        },
                        'json'
                    );
                    return false;
                })
                .on('modal:shown', function() {
                    var $el = $searchModal.find('input');
                    $el.trigger('input');
                })
        }
    });

var $productsFilter = $('#products-filter');
var $pageDescription = $('#page-description');

if ($productsFilter.length) {
    $productsFilter.on('click', '.dropdown-item', function() {
        preloader(1);
        $productsFilter.find('input[name="order"]').val($(this).data('order'));
        $productsFilter.submit();
    })
}

if ($pageDescription.length && $pageDescription[0].scrollHeight > $pageDescription[0].offsetHeight) {
    $pageDescription.addClass('is-truncated');
    $pageDescription.click(function(){
        $(this).toggleClass('is-expanded is-truncated');
    });
}
$body
    .on('modal:shown', '.collage-buy-modal', function() {
        var $form = $(this).find('form');
        if ($form.length > 0 && !$form[0].validator) {
            $form.formValidate();
        }
    })
    .on('touchstart', '.modal-page header', function(e) {
        if (e.touches.length > 1) {
            return true;
        }

        var $el = $(this);
        var $modal = $el.closest('.modal');


        if ($modal.is('.modal-connect') || $modal.is('.modal-fixed')) {
            return true;
        }

        var height = $(window).height();
        var diff;
        var throttled = false;
        var start =  {
            x: e.touches[0].clientX,
            y: e.touches[0].clientY,
            ts: (new Date()).getTime()
        }
        var css = $modal.attr('style');

        var touchMove = function(e) {
            if (!throttled) {
                throttled = true;
                window.requestAnimationFrame(function() {
                    diff = {
                        x: e.touches[0].clientX - start.x,
                        y: e.touches[0].clientY - start.y
                    };
                    if (diff.y < 0) {
                        diff.y = 0;
                    }
                    $modal.css({
                        'transform': 'translate3d(0, ' +  diff.y + 'px, 0)',
                        'transition': 'none'
                    });
                    throttled = false;
                })
            }
        }

        var touchEnd = function(e) {
            $el.off('touchmove', touchMove);
            if (!diff) {
                return;
            }

            if (diff.y === 0) {
                $modal.attr('style', css);
                return;
            }
            e.preventDefault();
            window.requestAnimationFrame(function() {
                var duration = 100;
                var velocity = Math.abs(diff.y) / ((new Date()).getTime() - start.ts);
                if (Math.abs(diff.y) >= (height / 3) || velocity >= 0.3) {
                    var y = diff.y > 0 ? height : -height;
                    $modal.css({
                        'transform': 'translate3d(0, ' +  y + 'px, 0)',
                        'transition': 'transform ' + duration + 'ms'
                    });
                    setTimeout(function() {
                        $modal
                            .one('modal:hidden', function() {
                                $modal.attr('style', css);
                            }).modal('hide');
                    }, duration)
                } else {
                    $modal.css({
                        'transform': 'translate3d(0, 0, 0)',
                        'transition': 'transform ' + duration + 'ms'
                    });
                    setTimeout(function() {
                        $modal.attr('style', css);
                    }, duration)
                }
            })
        }
        $el.on('touchmove', touchMove);
        $el.one('touchend', touchEnd);
    })
    .on('click', '.collage-buy-submit', function() {
        $(this).closest('.modal').find('form').submit();
        return false;
    })
    .on('change', '.collage-buy-product', function() {
        var $form = $(this).closest('form');

        if ($form.find('.collage-buy-product:checked').length === 0) {
            $form.closest('.modal').find('.collage-buy-submit').attr('disabled', '')
        } else {
            $form.closest('.modal').find('.collage-buy-submit').removeAttr('disabled')
        }
    })
    .on('success', '.collage-buy-form', function(e, response) {
        var $submit = $(this).closest('.modal').find('.collage-buy-submit');
        updateCartButton(response.metadata)
        $submit.next().removeAttr('hidden');
        $submit.remove();
        dilytics('collage', 'addToCart', [$(this).closest('.campaign-collage').data('id')]);
    })
    .on('click', '.campaign-product', function(e) {
        var $el = $(this);
        e.preventDefault();
        preloader(1);
        dilytics('collage', 'click', [$el.closest('.campaign-collage').data('id')]);
        setTimeout(function() {
            location.href = $el.attr('href');
        }, 200)
        return false;
    })

var $campaignCollages = $('.campaign-collage');

if ($campaignCollages.length > 0) {
    var ids = [];
    $campaignCollages.each(function() {
        ids.push($(this).data('id'));
    })
    dilytics('collage', 'view', ids);
}
$body.on('error', 'form', (e, err) => {
    if (typeof Rollbar !== 'undefined') {
        Rollbar.error('Form error', {response: err, payload: $(e.target).data('payload') || 'unknown'});
    }
});
preloader(0);
loadjs.done('core');